@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  @for (organisations of organisationsByCountry | keyvalue; track organisations.key) {
    <app-delivery-report-organisations-by-country
      [organisationsByCountry]="organisations"
      [isPrintView]="isPrintView()"
    ></app-delivery-report-organisations-by-country>
  }
}
